import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  tableLoading,
  checkPermission,
  customStyle,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import { FoodContext } from "../../../../../contexts/Food";

const toastObj = {
  position: "bottom-center",
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  className: "text-center toast-notification",
}

const FinishGoodsAcceptanceView = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const params = useParams()
    //getting context values here
    let {
      loading,
      setLoading,
      branchForSearch,
      branchListWeb
    } = useContext(RestaurantContext);

    let { foodForPOS } = useContext(FoodContext)

    let {
      //Good acceptance
      setFinishedGoodsAcceptanceList,
      setFinishedGoodsAcceptanceListForSearch,
      authUserInfo,
    } = useContext(UserContext);

    // States hook here
    //new item
    let [newFinishGoods, setNewFinishGoods] = useState({
      document_no: "",
      fromBranch: null,
      toBranch: null,     
      remarks: "",
    });
    let rowId = useRef(0);
    //new Row
    const [newRow,setNewRow]=useState([]);

    //edit stock
    const [editStock,setEditStock]=useState(null);

    //check edit or view
    const [isEdit,setIsEdit]=useState(null);
  
    //datepicker
    const [documentDate, setDocumentDate] = useState(new Date());

    //Get Specific item for edit
    const getFinishedGoodsItem = async () => {
      setLoading(true);
      const url = BASE_URL +
        "/settings/get-finished-good-transfer-edit/" + parseInt(params.id);
      try {
        const res = await axios
          .get(url, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          });
          if(res){
            setEditStock(res.data)
          }
          setLoading(false);
      } catch {
        setLoading(false);
        toast.error(`${_t(t("Something went wrong"))}`, toastObj);
      }
    };
  
    useEffect(() => {
      getFinishedGoodsItem();
      if (window.location.pathname.includes("-edit")) {
        setIsEdit(true)
      }else{
        setIsEdit(false)
      }
    }, []);

    useEffect(()=>{
      if(editStock && editStock !== null && branchListWeb){
        let docDate = new Date(editStock[0]?.document_date);
        let fromBranch = branchListWeb?.find((item)=>editStock[0].from_branch_id === item.id)
        let toBranch = branchListWeb?.find((item)=>editStock[0].to_branch_id === item.id)
        setNewFinishGoods({
          ...newFinishGoods,
          document_no: editStock[0]?.document_identity,
          fromBranch,
          toBranch,
          remarks:editStock[0]?.remarks,
        })
        setDocumentDate(docDate);
        let rowArr=[];
        if(editStock[1] && editStock[1].length > 0){
          editStock[1].map((item)=>{
            rowArr.push({
              ...item,
              id: rowId.current,
              qty:parseInt(item.qty),
              fixed_qty:parseInt(item.qty),
              transfer_qty: parseInt(item.transfer_qty),
              isEdit:true
            })
            rowId.current += 1
          })
          setNewRow([...rowArr]);
        }
      }
    },[editStock, branchListWeb])

  
    //set each item qty
    const handleItemQty = (index,e) => {
      if(parseInt(e.target.value) > newRow[index].fixed_qty){
        toast.error(`${_t(t(`Must be less than or equal to ${newRow[index].fixed_qty}`))}`, toastObj);
      }else{
        newRow[index].qty=e.target.value;
        setNewRow([...newRow]);
      }
    };
  
    //post req of stock item update
    const editFinishAxios = async () => {
      let date =
        new Date(documentDate).getFullYear() +
        "-" +
        (new Date(documentDate).getMonth() + 1) +
        "-" +
        new Date(documentDate).getDate();

      let slugArray=[];
      newRow.map((finishGoods) => {
        if(finishGoods.item_name === ""){
          slugArray.push();
        }else{
          slugArray.push({
            qty: parseInt(finishGoods?.qty),
            item_id: finishGoods?.isEdit ? finishGoods?.item_id : finishGoods?.item_name?.id,
            item_name: finishGoods?.isEdit ? finishGoods?.item_name : finishGoods?.item_name?.name,
            stock_qty: 0,
            transfer_qty: parseInt(finishGoods?.transfer_qty)        
          });
        }
      });
        
      if(newRow.length === slugArray.length){
        setLoading(true);
        let formData = {
          id:params.id,
          document_no:newFinishGoods.document_no,
          from_branch_id: newFinishGoods.fromBranch.id,
          to_branch_id: newFinishGoods.toBranch.id,     
          document_date: date,
          remarks: newFinishGoods.remarks,
          is_acceptance:1,
          items: slugArray,
        };   
        // console.log("check form data==>",formData);   
        const url = BASE_URL + "/settings/update-finished-good-transfer";
        try {
            const res = await axios.post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          });
          setFinishedGoodsAcceptanceList(res.data[0]);
          setFinishedGoodsAcceptanceListForSearch(res.data[1]);
          setLoading(false);
          toast.success(`${_t(t("Goods Acceptance has been updated"))}`,toastObj);
          history.push("/dashboard/manage/stock/finished-goods-acceptance")
        } catch (error) {
          console.log("check error==>",error);
          if(error.response.status === 403) {
            toast.error(error.response.data.message, toastObj);
          }else if(error.response.data?.message){
          toast.error(error.response.data.message, toastObj);
          }else{
            toast.error(`${_t(t("Please try again later"))}`, toastObj);
          }
          setLoading(false);
        }
      }else{
        toast.error(`${_t(t("Please select all dropdowns"))}`, toastObj);
      }
    };
  
    //send to server
    const handleSubmit = (e) => {
      e.preventDefault();
      if (
        newFinishGoods.toBranch !== null &&
        newFinishGoods.fromBranch !== null &&
        newFinishGoods.document_no !== null &&
        documentDate !== null
      ) {
        if(newRow.length > 0){
          editFinishAxios();
        }
        else{
          toast.error(`${_t(t("Please add goods"))}`, toastObj);
        }
      } else {
        toast.error(`${_t(t("Please fill all the required fields"))}`,toastObj);
      }
    };
  
    return (
      <>
        <Helmet>
          <title>{_t(t("Finished Goods Acceptance"))}</title>
        </Helmet>
  
        {/* main body */}
        <main id="main" data-simplebar>
          <div className="container-fluid">
            <div className="row t-mt-10 gx-2">
              {/* left Sidebar */}
              <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
                <ManageSidebar />
              </div>
              {/* left Sidebar ends */}
  
              {/* Rightbar contents */}
              <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
                <div className="t-bg-white">
                  <div
                    className="fk-scroll--pos-menu table-bottom-info-hide"
                    data-simplebar
                  >
                    <div className="t-pl-15 t-pr-15">
                      {/* next page data spin loading */}
                      {/* <div className={`${dataPaginating && "loading"}`}></div> */}
                      {/* spin loading ends */}
  
                      {/* Loading effect */}
                      {loading === true ? (
                        tableLoading()
                      ) : (
                        <div key="smtp-form">
                          <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                            <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                              <ul className="t-list fk-breadcrumb">
                                <li className="fk-breadcrumb__list">
                                  <span className="t-link fk-breadcrumb__link text-capitalize">
                                    {isEdit ? _t(t("Edit Finished Goods Acceptance")) : _t(t("View Finished Goods Acceptance"))}
                                  </span>
                                </li>
                              </ul>
                            </div>
                            <div className="col-md-6 col-lg-7">
                              <div className="row gx-3 align-items-center"></div>
                            </div>
                          </div>
  
                          {/* Form starts here */}
                          <form
                            className="row card p-2 mx-3 mb-5 table-text"
                            onSubmit={handleSubmit}
                            autoComplete="off"
                          >
                            <div className="col-12">
                            <div className="row">
                                <div className="form-group col-4 mt-3">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="document no"
                                      className="control-label"
                                    >
                                      {_t(t("Document no"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <input
                                      readOnly
                                      type="text"
                                      className="form-control table-text"
                                      id="document_no"
                                      name="document_no"                                      
                                      value={newFinishGoods.document_no}
                                      placeholder="Auto no"
                                      required
                                    />
                                  </div>
                                </div>
  
                                <div className="form-group col-4 text-right mt-3">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transfer_date"
                                      className="control-label"
                                    >
                                      {_t(t("Document Date"))}
                                      <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <DatePicker
                                      selected={documentDate}
                                      onChange={(date) => setDocumentDate(date)}
                                      peekNextMonth
                                      showMonthDropdown
                                      showYearDropdown
                                      dropdownMode="select"
                                      className="form-control table-text"
                                      placeholderText={_t(t("Document date"))}
                                      shouldCloseOnSelect={false}
                                      disabled={true}
                                    />
                                  </div>
                                </div>
                                  
                                <div className="form-group mt-3 col-4">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="branch"
                                      className="control-label"
                                    >
                                      {_t(t("Branch"))}
                                      <span className="text-danger">*</span>                                        
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newFinishGoods.fromBranch || null}
                                    classNamePrefix="select"
                                    // onChange={handleSetBranch}
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }
                                    isDisabled={true}
                                  />
                                </div> 
                              </div>
  
                              <div className="row">
                                <div className="form-group mt-2 col-4">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="to-branch"
                                      className="control-label"
                                    >
                                      {_t(t("To Branch"))}
                                      <span className="text-danger">*</span>                                        
                                    </label>
                                  </div>
                                  <Select
                                    options={branchListWeb}
                                    components={makeAnimated()}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={newFinishGoods.toBranch || null}
                                    classNamePrefix="select"
                                    // onChange={handleSetToBranch}
                                    maxMenuHeight="200px"
                                    styles={customStyle}
                                    isDisabled={true}  
                                    placeholder={
                                      _t(t("Please select a branch")) + ".."
                                    }                                      
                                  />
                                </div>                                                          
                                <div className="form-group mt-2 col-8">
                                  <div className="mb-2">
                                    <label
                                      htmlFor="remarks"
                                      className="control-label"
                                    >
                                      {_t(t("Remarks"))}
                                    </label>
                                  </div>
                                  <div className="mb-2">
                                    <textarea
                                      type="text"
                                      className="form-control table-text"
                                      id="remarks"
                                      name="remarks"
                                      // onChange={handleRemarks}
                                      value={newFinishGoods.remarks || ""}
                                      placeholder="Remarks"
                                      style={{height:"33px"}}
                                      disabled={true}
                                    />
                                  </div>
                                </div>
                              </div>                            
                              
                              <div className={`table-responsive mt-3 pr-1 `}
                               style={{maxHeight:"23rem",overflow: "auto"}}>
                                <table className="table table-bordered-sm table-hover">
                                  <thead className="align-middle">                                    
                                    <tr>                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"35rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Item Name"))}
                                        </span>
                                      </th>                                     
                                      
                                      <th
                                        scope="col"
                                        className="table-text text-capitalize align-middle text-center border-1 border"
                                        style={{width:"30rem"}}
                                      >
                                        <span style={{fontWeight:500}}>
                                        {_t(t("Qty"))}
                                        </span>
                                      </th>                                        
                                    </tr>
                                  </thead>
                                    {newRow && newRow.length>0 ?
                                  <tbody className="align-middle">
                                    {newRow.map(
                                      (finishGoods, index) => {
                                        return (
                                          <tr
                                            className="align-middle"
                                            key={index}
                                          >                                            
                                            <td className="table-text text-capitalize align-middle text-center">                                                
                                              {
                                                finishGoods?.isEdit ? (
                                                  <input
                                                    readOnly
                                                    type="text"
                                                    className={`form-control text-center table-Input table-text`}
                                                    value={finishGoods.item_name || ""}
                                                  />
                                                ) : (
                                                  <Select
                                                    menuPosition="fixed"
                                                    options={foodForPOS !== null ? foodForPOS : []}
                                                    // components={makeAnimated()}
                                                    getOptionLabel={(option) => option.name}
                                                    getOptionValue={(option) => option.id}
                                                    // onChange={(e)=>handleSetItems(index,e)}
                                                    value={finishGoods.item_name}
                                                    styles={customStyle}                                              
                                                      placeholder={
                                                      _t(t("Please select items")) + ".."
                                                      }  
                                                    isDisabled={true}                                              
                                                  />
                                                )
                                              }
                                            
                                            </td>                                              

                                            <td className="table-text text-capitalize align-middle text-center">
                                              <input
                                                type="number"
                                                step="0.1"
                                                min="0"                                                  
                                                onKeyDown={(evt) =>
                                                  ["e", "E", "+", "-","ArrowUp","ArrowDown"].includes(evt.key) &&
                                                  evt.preventDefault()
                                                }
                                                onWheel={(e) => e.target.blur()}
                                                className="form-control text-center table-Input table-text"
                                                id={finishGoods.id}
                                                name={finishGoods.id}
                                                onChange={(e)=>handleItemQty(index,e)}
                                                value={                                                    
                                                  finishGoods.qty
                                                }
                                                placeholder="Qty"
                                                required  
                                                disabled={true}                                                
                                              />
                                            </td>                                                                                            
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                  :null}
                                
                                </table>
                              </div>
  
                              <div className="form-group mt-4 pb-2">                                
                                <div className="d-flex justify-content-end align-items-center">
                                  <div className="col-3 d-flex justify-content-end">
                                    <button
                                      type="button"
                                      className="btn rounded hov-btn mr-3"
                                      onClick={()=>(history.push("/dashboard/manage/stock/finished-goods-acceptance"))}                                
                                    >
                                      <i class="fa fa-arrow-left" aria-hidden="true"></i> {_t(t("Back"))}
                                    </button>
                                    {checkPermission(authUserInfo.permissions, "FG Accept") && (isEdit ? 
                                      <button
                                      disabled={loading}
                                      type="submit"
                                      className="btn btn-primary rounded"
                                      >
                                        <i class="fa fa-floppy-o" aria-hidden="true"></i> {_t(t("Accept"))}
                                      </button> : null )}                                                   
                                  </div>                                                    
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* Rightbar contents end*/}
            </div>
          </div>
        </main>
        {/* main body ends */}     
      </>
    );
}

export default FinishGoodsAcceptanceView;
